/**
 * Pushes an event to the dataLayer
 * @param data
 */
export const pushEvent = (data) => {
  const dataLayer = (window.dataLayer = window.dataLayer || [])
  dataLayer.push(data)
}
